import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import { api } from "../_services/api.service";
import { Row, Col, Card, CardBody, CustomInput, Button } from "reactstrap";
import Loader from "react-loaders";
import PageTitle from "../Layout/AppMain/PageTitle";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import AvField from "availity-reactstrap-validation/lib/AvField";
import { toast } from "react-toastify";
import AppCache from "../_helpers/appCache";
import swal from "sweetalert";
import DropIn from "braintree-web-drop-in-react";
import BraintreePartner from "../Components/BraintreePartner";

const RegisterPartner = (props) => {
  let [partner, setPartner] = useState({
    partnerID: -1,
    partnerName: "",
    description: "",
    partnerType: "",
  });
  let [isLoading, setIsLoading] = useState(false);

  let [user, setUser] = useState(null);
  let [passwordError, setPasswordError] = useState(false);

  const successToastOpts = {
    autoClose: 3000,
    type: toast.TYPE.SUCCESS,
    hideProgressBar: false,
  };

  const loadData = (pid) => {
    setIsLoading(true);
    api.getPartnerById(pid).then((data) => {
      if (
        data.partnerSubscriptionStartDT == undefined ||
        data.partnerSubscriptionStartDT == null
      ) {
        data.partnerSubscriptionStartDT = new Date(2020, 1, 1);
      } else {
        data.partnerSubscriptionStartDT = new Date(
          data.partnerSubscriptionStartDT
        );
      }

      AppCache.setPartner(data.partnerID, data.partnerName);
      setPartner({ ...partner, ...data });

      loadOwner(data.ownerUserID);

      setIsLoading(false);
    });
  };

  const loadOwner = (id) => {
    api.getUserById(id).then((data) => {
      if (
        data.userSubscriptionStartDT == undefined ||
        data.userSubscriptionStartDT == null
      ) {
        data.userSubscriptionStartDT = new Date(2020, 1, 1);
      } else {
        data.userSubscriptionStartDT = new Date(data.userSubscriptionStartDT);
      }

      setUser(data);

      setIsLoading(false);
    });

  };

  const handleSubmit = (e, errors, values) => {
    setPasswordError(false);
    if (
      partner.password !== "" &&
      partner.password == partner.confirmPassword
    ) {
      if (errors.length == 0) {
        if (partner.partnerID > 0) {
          api.updatePartner(0, partner).then((data) => {
            toast("Partner updated successfuly", successToastOpts);
          });
        } else {
          api.createPartner(0, partner).then((id) => {
            toast("Partner created successfuly", successToastOpts);

            loadData(id);
          });
        }
      }
    } else {
      setPasswordError(true);
    }
  };

  return (
    <div style={{ padding: "40px" }}>
      <PageTitle
        icon="fas fa-building"
        heading="Register for a Definitive Choice Business Account"
      />
      {isLoading && <Loader style={{}} type="ball-pulse" active />}
      {!isLoading && partner !== null && (
        <Row>
          <Col md="6">
          <Card>
              <CardBody>
                  Please complete the form in order to setup your Definitive Choice Business account.  Your account name should be your business name as your users will see it.  If you already have an individual account, you can use the same email for this account if you wish or you can use a different one.

                  After submitting this form, you will be asked to signup for a subscription based on the number of users your account will support.

              </CardBody>
              </Card>
            <Card>
              <CardBody>
                <AvForm onSubmit={handleSubmit} >
                  <AvField
                    name="partnerName"
                    label="Account Name *"
                    autoComplete="Off"
                    value={partner.partnerName}
                    onChange={(e) =>
                      setPartner({ ...partner, partnerName: e.target.value })
                    }
                    placeholder="Enter..."
                    required
                  />

                  <AvField
                    name="firstname"
                    label="First Name *"
                    value={partner.firstName}
                    type="text"
                    onChange={(e) =>
                      setPartner({ ...partner, firstName: e.target.value })
                    }
                    placeholder="Enter..."
                    required
                  />

                  <AvField
                    name="lastname"
                    label="Last Name *"
                    value={partner.lastName}
                    type="text"
                    onChange={(e) =>
                      setPartner({ ...partner, lastName: e.target.value })
                    }
                    placeholder="Enter..."
                    required
                  />

                  <AvField
                    name="email"
                    label="Email *"
                    value={partner.email}
                    type="text"
                    onChange={(e) =>
                      setPartner({ ...partner, email: e.target.value })
                    }
                    placeholder="Enter..."
                    required
                  />

                  <AvField
                    name="pass"
                    label="Password *"
                    value={partner.password}
                    type="password"
                    onChange={(e) =>
                      setPartner({ ...partner, password: e.target.value })
                    }
                    placeholder="Enter..."
                    required
                  />

                  <AvField
                    name="confpass"
                    label="Confirm Password *"
                    value={partner.confirmPassword}
                    type="password"
                    onChange={(e) =>
                      setPartner({
                        ...partner,
                        confirmPassword: e.target.value,
                      })
                    }
                    placeholder="Enter..."
                    required
                  />
                  {passwordError && (
                    <span style={{ color: "red" }}>
                      Password and Confirm Password should match
                    </span>
                  )}

                  <AvField
                    name="description"
                    label="Description"
                    value={partner.description}
                    type="textarea"
                    style={{ height: "100px" }}
                    onChange={(e) =>
                      setPartner({ ...partner, description: e.target.value })
                    }
                    placeholder="Enter..."
                  />

                  
<div>
                          By registering you give consent to use your personal data to contact you, and to periodically send you communications about our solutions and services. 
                          (Note: Definitive will not sell your personal data to a third party or allow a third party to use your personal data for its own marketing purposes. <a href='https://www.definitivechoice.com/wp-content/uploads/2021/04/Definitives-Privacy-Notice.pdf' target='_blank'>Privacy Policy</a>)
                        </div>

                  <Button
                    color="link"
                    className="pull-right"
                    onClick={() => props.history.goBack()}
                  >
                    Cancel
                  </Button>
                  <Button color="primary" type="submit" className="pull-right">
                    Save
                  </Button>
                </AvForm>
              </CardBody>
            </Card>
          </Col>
          <Col md="6">{user !== null && <BraintreePartner user={user} partner={partner} fromRegister={true} history={props.history} />}</Col>
        </Row>
      )}
    </div>
  );
};

export default RegisterPartner;
